// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2L9ZP","SettingsMode":"Button_SettingsMode__2ElXH","SettingsButton":"Button_SettingsButton__2WxHV"};